import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";

import fondo from "../assets/fondo1.jpg";
import SectionHeader from "./SeccionHeader";

// 👉 IMÁGENES
import img1 from "../assets/tattoo1.jpg";
import img2 from "../assets/tattoo2.jpg";
import img3 from "../assets/tattoo3.jpg";
import img4 from "../assets/tattoo4.jpg";
import img5 from "../assets/tattoo5.jpg";
import img6 from "../assets/tattoo6.jpg";
import img7 from "../assets/tattoo7.jpg";
import img8 from "../assets/tattoo8.jpg";
import img9 from "../assets/tattoo9.jpg";
import img10 from "../assets/tattoo10.jpg";
import img11 from "../assets/tattoo11.jpg";
import img12 from "../assets/tattoo12.jpg";
import img13 from "../assets/tattoo13.jpg";
import img14 from "../assets/tattoo14.jpg";
import img15 from "../assets/tattoo15.jpg";
import img16 from "../assets/tattoo16.jpg";

// 🎬 VIDEOS
import videoProyecto from "../assets/videoproyecto.mp4";
import videoProyecto2 from "../assets/videoproyecto2.mp4";


// 🔥 MEDIA
const media = [
  "VIDEO2",
  img1,
  img2,
  img3,
  img4,
  img5,
  "VIDEO",
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
];

const Proyectos = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const { t } = useTranslation();

  // ================= ANIMACIONES =================
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const stagger = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  // ================= MODAL =================
  const nextImage = () => {
    setSelectedIndex((prev) => (prev + 1) % media.length);
  };

  const prevImage = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? media.length - 1 : prev - 1
    );
  };

  // ================= RENDER MEDIA =================
  const renderMedia = (item, isModal = false) => {
    if (item === "VIDEO") {
      return (
        <video
          src={videoProyecto}
          autoPlay
          muted
          loop
          playsInline
          controls={isModal}
          className={`object-contain ${
            isModal
              ? "max-h-[80vh] max-w-[90vw]"
              : "w-full h-[420px] object-cover rounded-xl border border-[#3C2B22]/40 shadow-xl"
          }`}
        />
      );
    }

    if (item === "VIDEO2") {
      return (
        <video
          src={videoProyecto2}
          autoPlay
          muted
          loop
          playsInline
          controls={isModal}
          className={`object-contain ${
            isModal
              ? "max-h-[80vh] max-w-[90vw]"
              : "w-full h-[420px] object-cover rounded-xl border border-[#3C2B22]/40 shadow-xl"
          }`}
        />
      );
    }

    return (
      <img
        src={item}
        alt={t("projects.alt")}
        className={`${
          isModal
            ? "max-h-[80vh] max-w-[90vw] object-contain"
            : "w-full h-[420px] object-cover transition duration-700 group-hover:scale-110 group-hover:opacity-80"
        }`}
      />
    );
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden font-montserrat">

      {/* BACKGROUND */}
      <img
        src={fondo}
        alt="fondo"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* OVERLAY */}
      <div className="absolute inset-0 bg-[#0E0B09]/80 backdrop-blur-sm" />

      {/* CONTENIDO */}
      <div className="relative z-10 px-6 md:px-12 py-28 max-w-7xl mx-auto">

        <SectionHeader
          title={t("projects.title")}
          subtitle1={t("projects.subtitle1")}
          subtitle2={t("projects.subtitle2")}
        />

        {/* GRID */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8"
          variants={stagger}
          initial="hidden"
          animate="show"
        >
          {media.map((item, index) => (
            <motion.div
              key={index}
              variants={fadeUp}
              className="relative overflow-hidden cursor-pointer group"
              onClick={() => setSelectedIndex(index)}
            >
              {renderMedia(item)}

              <div className="absolute inset-0 bg-[#0E0B09]/20 opacity-0 group-hover:opacity-100 transition duration-500" />
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* MODAL */}
      <AnimatePresence>
        {selectedIndex !== null && (
          <motion.div
            className="fixed inset-0 bg-[#0E0B09]/95 backdrop-blur-md flex items-center justify-center z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            {/* CLOSE */}
            <button
              onClick={() => setSelectedIndex(null)}
              className="
                absolute top-6 right-6
                text-[#B8977F]
                bg-black/40
                p-2
                rounded-full
                hover:bg-black/70
                transition
              "
            >
              <FiX size={18} />
            </button>

            {/* MEDIA */}
            <motion.div
              key={selectedIndex}
              initial={{
                scale: 0.85,
                opacity: 0,
              }}
              animate={{
                scale: 1,
                opacity: 1,
              }}
              exit={{
                scale: 0.85,
                opacity: 0,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              {renderMedia(media[selectedIndex], true)}
            </motion.div>

            {/* PREV */}
            <button
              onClick={prevImage}
              className="
                absolute left-6
                text-[#B8977F]
                text-4xl
                hover:text-[#EDE0D0]
                transition
              "
            >
              ‹
            </button>

            {/* NEXT */}
            <button
              onClick={nextImage}
              className="
                absolute right-6
                text-[#B8977F]
                text-4xl
                hover:text-[#EDE0D0]
                transition
              "
            >
              ›
            </button>
          </motion.div>
        )}
      </AnimatePresence>

    </div>
  );
};

export default Proyectos;